import React from "react";

const NumbersToWords = ({ number }) => {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const convertNumberToWords = (num) => {
    if (num === 0) return "-";

    const convertLessThanThousand = (num) => {
      //   if (num === 10) return "Ten" + &nbsp;;
      if (num === 10) return "Ten";
      if (num < 10) return units[num];
      if (num < 20) return teens[num - 11];
      if (num < 100) return tens[Math.floor(num / 10)] + " " + units[num % 10];
      return (
        units[Math.floor(num / 100)] +
        " Hundred " +
        convertLessThanThousand(num % 100)
      );
    };

    const convert = (num) => {
      if (num === 0) return "";
      if (num < 1000) return convertLessThanThousand(num);
      const crore = Math.floor(num / 10000000);
      const lakh = Math.floor((num % 10000000) / 100000);
      const thousand = Math.floor((num % 100000) / 1000);
      const remainder = num % 1000;

      let result = "";
      if (crore > 0) result += convertLessThanThousand(crore) + " Crore ";
      if (lakh > 0) result += convertLessThanThousand(lakh) + " Lakh ";
      if (thousand > 0)
        result += convertLessThanThousand(thousand) + " Thousand ";
      if (remainder > 0) result += convertLessThanThousand(remainder);

      return result;
    };

    return convert(num) + " Rupees Only/-";
  };

  return (
    <div>
      <p style={{ margin: "0" }}>
        <strong>{convertNumberToWords(Math.round(number))}</strong>
      </p>
    </div>
  );
};

export default NumbersToWords;
